// Runtime configuration for the admin portal.
//
// CRA inlines process.env.REACT_APP_* at build time, which would pin a build to a single
// environment. CI builds with those values blanked and the deploy writes public/config.js
// for the target environment, so read configuration through this module rather than
// process.env directly. Local development still works via the .env files.
const runtimeEnv = (typeof window !== "undefined" && window.__ENV__) || {};

const definedRuntimeEntries = Object.entries(runtimeEnv).filter(
  ([, value]) => value !== undefined && value !== null && value !== ""
);

const env = Object.freeze({
  ...process.env,
  ...Object.fromEntries(definedRuntimeEntries),
});

export default env;
